import React from 'react';
import { Fragment } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import logo from '../../assets/images/logo.png';
import '../../styles/footer.scss';

function Footer() {
    return (
        <Fragment>
            <footer className='rodape'>
                <Container>
                    <Row xs={1}>
                        <Col>
                            <img src={logo} className="brasao-ft" alt="Consórcio LVF" />
                        </Col>
                    </Row>
                </Container>
            </footer>
        </Fragment>
    )
}

export default Footer;